import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import ProjectCard from "./ProjectCard";
import WorkLightbox from "./WorkLightbox";
import { useContent, useSiteText } from "../lib/content";

export const SelectedWork = () => {
  const trackRef = useRef(null);
  const [open, setOpen] = useState(null);
  const { projects: PROJECTS } = useContent();
  const t = useSiteText();

  const scrollTrack = (dir) =>
    trackRef.current?.scrollBy({ left: dir * 360, behavior: "smooth" });

  return (
    <section
      id="work"
      data-testid="work-section"
      className="relative bg-[#0a0a0c] pt-12 md:pt-14 pb-20 md:pb-28 overflow-hidden"
    >
      <div className="px-6 md:px-12 lg:px-16 flex items-end justify-between gap-8">
        <div>
          <span className="text-[11px] uppercase tracking-[0.3em] text-white/85">
            {t("work_label", "Selected Work")}
          </span>
          <div className="mt-2 h-px w-9 bg-[#c8b99d]" />
        </div>
        <Link
          to="/work"
          data-testid="work-view-all"
          className="group inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-white/50 hover:text-white transition-colors"
        >
          View All Projects
          <ArrowRight
            size={13}
            className="group-hover:translate-x-1 transition-transform duration-300"
          />
        </Link>
      </div>

      <div className="relative mt-10" data-testid="work-carousel">
        <div
          ref={trackRef}
          className="flex gap-4 md:gap-5 overflow-x-auto no-scrollbar snap-x snap-mandatory px-6 md:px-12 lg:px-16"
        >
          {PROJECTS.map((p, i) => (
            <ProjectCard
              key={p.title}
              p={p}
              i={i}
              onOpen={setOpen}
              className="min-w-[270px] md:min-w-[330px] snap-start"
            />
          ))}
        </div>
        <button
          onClick={() => scrollTrack(-1)}
          data-testid="work-prev"
          aria-label="Previous projects"
          className="hidden md:flex absolute left-2 top-[110px] items-center justify-center border border-white/15 bg-black/70 p-2.5 text-white/60 hover:text-white hover:border-white transition-colors"
        >
          <ChevronLeft size={18} strokeWidth={1.25} />
        </button>
        <button
          onClick={() => scrollTrack(1)}
          data-testid="work-next"
          aria-label="Next projects"
          className="hidden md:flex absolute right-2 top-[110px] items-center justify-center border border-white/15 bg-black/70 p-2.5 text-white/60 hover:text-white hover:border-white transition-colors"
        >
          <ChevronRight size={18} strokeWidth={1.25} />
        </button>
      </div>

      <WorkLightbox
        project={open !== null ? PROJECTS[open] : null}
        index={open ?? 0}
        total={PROJECTS.length}
        onClose={() => setOpen(null)}
      />
    </section>
  );
};

export default SelectedWork;
